import api from './api'

export const groupService = {
  getAll: () =>
    api.get('/customer-groups'),

  getById: (id: number | string) =>
    api.get(`/customer-groups/${id}`),

  create: (data: {
    group_name: string
    group_code: string
    price_tier: string
    payment_terms_days?: number
    credit_limit?: number
    discount_percent?: number
  }) => api.post('/customer-groups', data),

  update: (id: number | string, data: {
    group_name?: string
    group_code?: string
    price_tier?: string
    payment_terms_days?: number
    credit_limit?: number
    discount_percent?: number
  }) => api.put(`/customer-groups/${id}`, data),

  delete: (id: number | string) =>
    api.delete(`/customer-groups/${id}`),
}
